import { MODURI, type ContextCurs, type ModCurs } from '@/lib/money'

const CHEIE = 'et.curs.mod'

export function citesteMod(): ModCurs {
  const v = localStorage.getItem(CHEIE) as ModCurs | null
  return v && MODURI.some((m) => m.id === v) ? v : 'auto'
}

/** Selectorul de curs. Alegerea se tine minte intre sesiuni — operatorul care lucreaza cu
 *  cursul bancii nu si-l reseteaza la fiecare deschidere. */
export function CursSelector({
  ctx, onMod, onManual,
}: {
  ctx: ContextCurs
  onMod: (m: ModCurs) => void
  onManual: (v: number | null) => void
}) {
  const activ = MODURI.find((m) => m.id === ctx.mod) ?? MODURI[0]!
  return (
    <div className="flex items-center gap-2">
      <label className="text-[12.5px] text-muted" htmlFor="curs-mod">Curs</label>
      <select
        id="curs-mod"
        value={ctx.mod}
        onChange={(e) => {
          const m = e.target.value as ModCurs
          localStorage.setItem(CHEIE, m)
          onMod(m)
        }}
        title={activ.explicatie}
        className="h-9 px-2.5 rounded-[var(--radius-control)] border border-line bg-surface text-[13.5px]"
      >
        {MODURI.map((m) => (
          <option key={m.id} value={m.id}>{m.label}</option>
        ))}
      </select>
      {ctx.mod === 'manual' && (
        <input
          type="number"
          step="0.0001"
          min="0"
          inputMode="decimal"
          defaultValue={ctx.manual ?? undefined}
          onChange={(e) => onManual(e.target.value ? Number(e.target.value) : null)}
          placeholder="5,2534"
          aria-label="Curs introdus"
          className="tnum h-9 w-24 px-2.5 rounded-[var(--radius-control)] border border-line bg-surface text-[13.5px]"
        />
      )}
    </div>
  )
}
